// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"2db48d43","423":"928f25d7"}[chunkId] + ".chunk.js";
};